import React, { useState } from 'react';
import { FiMail, FiPhone, FiMapPin, FiSend, FiCheck } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import './Contact.css';

const Contact = () => {
  const { t } = useTranslation('common');
  const [formData, setFormData] = useState({
    name: '', email: '', company: '', phone: '', subject: '', message: ''
  });
  const [status, setStatus] = useState({ loading: false, success: false, error: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: '' });

    try {
      await axios.post('/api/contact', formData);
      setStatus({ loading: false, success: true, error: '' });
      setFormData({ name: '', email: '', company: '', phone: '', subject: '', message: '' });
    } catch (error) {
      setStatus({
        loading: false,
        success: false,
        error: error.response?.data?.error || t('contact.page.errorGeneric')
      });
    }
  };

  const offices = t('footer.offices', { returnObjects: true });

  return (
    <div className="contact-page">
      <section className="page-hero">
        <div className="container">
          <p className="page-label">{t('contact.page.heroLabel')}</p>
          <h1>{t('contact.page.heroTitle')}</h1>
          <p className="page-description">{t('contact.page.heroDescription')}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="contact-form-wrapper">
              <h2>{t('contact.page.formTitle')}</h2>

              {status.success ? (
                <div className="success-message">
                  <FiCheck className="success-icon" />
                  <h3>{t('contact.page.successTitle')}</h3>
                  <p>{t('contact.page.successMessage')}</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name">{t('contact.page.nameRequired')}</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder={t('contact.page.namePlaceholder')}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email">{t('contact.page.emailRequired')}</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder={t('contact.page.emailPlaceholder')}
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="company">{t('contact.page.company')}</label>
                      <input
                        type="text"
                        id="company"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                        placeholder={t('contact.page.companyPlaceholder')}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="phone">{t('contact.page.phone')}</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder={t('contact.page.phonePlaceholder')}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="subject">{t('contact.page.subject')}</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      placeholder={t('contact.page.subjectPlaceholder')}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">{t('contact.page.message')}</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="5"
                      placeholder={t('contact.page.messagePlaceholder')}
                    ></textarea>
                  </div>

                  {status.error && <p className="error-text">{status.error}</p>}

                  <button type="submit" className="btn btn-primary" disabled={status.loading}>
                    {status.loading ? t('contact.page.sending') : t('contact.page.send')}
                    <FiSend />
                  </button>
                </form>
              )}
            </div>

            {/* Contact Info */}
            <div className="contact-info">
              <h2>{t('contact.page.infoTitle')}</h2>

              <div className="info-item">
                <FiMail className="info-icon" />
                <div>
                  <h4>{t('contact.page.emailLabel')}</h4>
                  <a href="mailto:contact@infini-nova.com">contact@infini-nova.com</a>
                </div>
              </div>

              <div className="info-item">
                <FiPhone className="info-icon" />
                <div>
                  <h4>{t('contact.page.phoneLabel')}</h4>
                  <a href="tel:+15025369198">{t('contact.phoneNumber')}</a>
                </div>
              </div>

              <div className="offices-section">
                <h3>{t('contact.page.officesTitle')}</h3>
                {Array.isArray(offices) && offices.map((office, index) => (
                  <div key={index} className="office-item">
                    <FiMapPin className="info-icon" />
                    <div>
                      <p>{office}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
